import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppContext } from '../../app/Context';
import { getUrl, setUrl } from '../../db/shared';
import { getSession } from '../../db/session';
import { getActiveSlideId, onSlideSelectionChanged } from '../../db/ppt';
import routes from '../../routes/router';

const useAutoNavigator = () => {
  const { session, setSession, isPresenting, presentationId, activeSlideId } = useAppContext();

  const navigate = useNavigate();

  // trigger when user focuses on a different slide
  const handleSlideSelectionChanged = useCallback(async () => {
    if (!presentationId) return;
    if (!activeSlideId) return;

    const localStorageSession = getSession();
    const newActiveSlideId = await getActiveSlideId();

    if (activeSlideId !== newActiveSlideId) {
      return;
    }

    if (!localStorageSession) {
      setSession(null);
      navigate(routes.auth.url(), { replace: true });
      return;
    }

    const url = getUrl(presentationId, activeSlideId) ?? routes.home.url();

    if (!session) {
      setSession(localStorageSession);
      navigate(url, { replace: true });
      return;
    }

    if (localStorageSession.token === session.token) {
      return;
    }

    if (localStorageSession.email === session.email) {
      setSession(localStorageSession);
      return;
    }

    setSession(localStorageSession);
    navigate(url, { replace: true });
  }, [session, presentationId, activeSlideId]);

  useEffect(() => {
    if (isPresenting) return;
    onSlideSelectionChanged(handleSlideSelectionChanged);
  }, [isPresenting, handleSlideSelectionChanged]);

  useEffect(() => {
    if (!presentationId) return;
    if (!activeSlideId) return;

    if (!session?.token) return;

    const url = getUrl(presentationId, activeSlideId) ?? routes.home.url();
    navigate(url, { replace: true });
  }, [presentationId, activeSlideId, session?.token]);
};

export default useAutoNavigator;
